<script lang="ts">
import { useStateManager } from '@/store'
import { defineComponent } from 'vue'

/**
 * This redirect component is mainly used for local saml sso test system. In real life, the request is redirected via
 * nginx (or traefik)
 */
export default defineComponent({
  name: 'SamlLogoutRedirect',
  mounted() {
    useStateManager().reset()

    // Redirect to https://www.itscope.com/saml/logout?[GIVEN_SAML_QUERY]&domain=shop-domain.de
    const url = window.STOREFRONT_API_BASE_URL

    const pathArray = url.split('/')
    const protocol = pathArray[0]
    const host = pathArray[2]
    const baseUrl = protocol + '//' + host

    const target =
      baseUrl + '/saml/logout' + window.location.search + '&domain=' + window.location.hostname
    window.open(target, '_self')
  }
})
</script>
